
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSchema]/purchase_credit",
      function () {
        return require("private-next-pages/[teamSchema]/purchase_credit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSchema]/purchase_credit"])
      });
    }
  